<template>
    <div class="tech">
        <div class="heading4">
            Frameworks & Tools
        </div>
        <div class="cards">
            <div class="card code">
                <div class="card-content">
                    
                    <div class="card-heading">Frameworks & Tools</div>
                    <div class="card-subheading">
                        Here is an overview of the kind of Languages, Frameworks and Tools I utilize in my practice.
                    </div>
                    <router-link to="/about" class="button-link2 code-button">READ MORE</router-link>
                    <img src="../assets/icons/code.svg" class="tiny-icon">
                </div>
            </div>
            <!-- <div class="card tools">
                <div class="card-content">
                    <div class="card-heading">Tools</div>
                    <div class="card-subheading">
                        Scope out the Software Tools I utilize in my daily practice.
                    </div>
                    <router-link to="" class="button-link2 tools-button">READ MORE</router-link>
                    <img src="../assets/icons/tool.svg" class="tiny-icon">
                </div>

            </div> -->
        </div>
    </div>
</template>
<style scoped>

.tiny-icon{
    margin-top:4.5rem;
    
}

.tech{
    padding:2rem;
}
.cards{
    display:flex;
    
    margin-top:2rem;
}

.card{
    flex:1;
    min-height:20rem;
    background-size:cover;
    background-blend-mode:hard-light;
    cursor: pointer;
    transition:0.4s;
    
}


/* .card:hover{
    transform:translateY(-10px);
} */

.tools{
    background-image: linear-gradient(var(--blue3),var(--blue3)), var(--tools);
}

.code{
    background-image: linear-gradient(var(--red),var(--red)), var(--code);
}

@media(max-width: 768px){
    .card{
        border-radius: var(--radius);
        margin-bottom:1.8rem;
        flex-direction: column;
    }
    .tech{
        padding:1rem;
    }

    .card-heading{
        font-size:1.4rem;
    }

    .card-subheading{
        text-align: center;
    }

.button-link2{
margin-top: 3rem;

}
.tiny-icon{
    margin-top:2.5rem;
    
}

/* .card:hover{
    transform:translateY(0px);
} */
}

.cards{
    flex-direction: column;
}

@media(max-width:950px){
    .card-content{
        padding:1rem;
    }

    
}
</style>